// Wait for Google Analytics to be ready
function waitForGA() {
  return new Promise((resolve) => {
    if (typeof gtag === 'function') {
      resolve();
    } else {
      // Check every 100ms for gtag
      const checkGA = setInterval(() => {
        if (typeof gtag === 'function') {
          clearInterval(checkGA);
          resolve();
        }
      }, 100);
      
      // Timeout after 10 seconds
      setTimeout(() => {
        clearInterval(checkGA);
        resolve();
      }, 10000);
    }
  });
}

document.addEventListener('DOMContentLoaded', async function () {
  console.log('Custom GA Events script loaded');
  
  // Wait for GA to be ready
  await waitForGA();
  
  // Check if gtag is available
  if (typeof gtag === 'function') {
    console.log('gtag function is available');
  } else {
    console.log('gtag function is NOT available');
  }

  // Event listener for "Download App" buttons
  const downloadButtons = document.querySelectorAll(
    'a.t4s-app-download-btn, #app-promotion-bottom-app-promotion-bottom a.t4s-bottom-btn, a[href*="id=com.illadriver"]'
  );

  console.log('Found download buttons:', downloadButtons.length);

  downloadButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      console.log('Download button clicked:', this.href);
      if (typeof gtag === 'function') {
        gtag('event', 'download_app', {
          'event_category': 'Engagement',
          'event_label': 'User clicked to download the app'
        });
        console.log('download_app event sent to GA');
      } else {
        console.log('gtag not available for download_app event');
      }
    });
  });

  // Event listener for "Request a Quote" form submission
  const quotationForm = document.querySelector('form.request-offer-form');
  console.log('Found quotation form:', quotationForm);
  
  if (quotationForm) {
    quotationForm.addEventListener('submit', function (e) {
      console.log('Quotation form submitted');
      if (typeof gtag === 'function') {
        gtag('event', 'request_quotation', {
          'event_category': 'Lead',
          'event_label': 'User submitted a request for a quotation'
        });
        console.log('request_quotation event sent to GA');
      } else {
        console.log('gtag not available for request_quotation event');
      }
    });
  }

    // Event listener for "Contact Buyer" button
  const contactBuyerButton = document.querySelector('#submit-form-button');
  console.log('Found contact buyer button:', contactBuyerButton);
  
  if (contactBuyerButton) {
    contactBuyerButton.addEventListener('click', function (e) {
      console.log('Contact buyer button clicked');
      if (typeof gtag === 'function') {
        gtag('event', 'contact_buyer', {
          'event_category': 'Lead',
          'event_label': 'User clicked contact buyer button'
        });
        console.log('contact_buyer event sent to GA');
      } else {
        console.log('gtag not available for contact_buyer event');
      }
    });
  }
});
